import React, { Component } from "react";
import Projectdetail from "./Projectdetail";
import Imagerow from "./components/Imagerow";
import Updates from "./components/Projupdates";

export class Sole extends Component {
  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/screenshots/lrg/aj12-indigo.jpg"
          heading="Social Sole"
          content={[
            <>
              <p>
                SocialSole is a fictional social media site built with the MERN stack, centered around the passion for sneakers. The site features a mock news section with articles related to
                sneakers, and users can register, post, and share their sneaker collections in the community section.
              </p>
            </>,
          ]}
          website="https://salty-stream-65536.herokuapp.com/"
          github="https://github.com/Jimmyelvis/socialsole"
          techs={[
            <>
              <li>React js.</li>
              <li>MongoDB</li>
              <li>Express js.</li>
              <li>Node js.</li>
              <li>Cloudinary</li>
              <li>Axios</li>
              <li>Sass</li>
            </>,
          ]}
          updates={[
            <>
              <h2 className="heading-2">Recent Updates</h2>

              <div className="updates">
                <Updates
                  heading="UPDATE 8/6/2023"
                  desc={[
                    <>
                      <h3 className="heading-3">I've implemented some significant updates to SocialSole. Here's what's new:</h3>

                      <ol className="list ordered-list">
                        <li>Complete Site Redesign: SocialSole now sports a modern and sleek design, enhancing the overall user experience.</li>

                        <li>Revamped Navbar Component: The Navbar has been redesigned for improved navigation and ease of use.</li>

                        <li>Realtime Search Overlay: Users can now perform searches in real-time through a dynamic overlay, providing quick and relevant results.</li>

                        <li>Redesigned Articles Section: The Articles section has been refined with a cleaner and more polished look.</li>

                        <li>
                          Enhanced User Dashboard: The user dashboard has received some significant additions:
                          <ul className="inner-list">
                            <li>Timeline: Users can now view not only their content but also posts from users they follow, keeping them up-to-date with their network's activities.</li>

                            <li>Centralized Comment View: All user comments are conveniently accessible in one place.</li>

                            <li>Liked Content Collection: Users can access all content they have liked, making it simple to revisit their favorites.</li>

                            <li>Custom Lists: Users can now create and manage custom lists, allowing them to save articles, posts, and sneakers for future reference.</li>

                            <li>Admins can handpick and feature specific posts, sneakers, and articles, showcasing them prominently in their respective sections.</li>
                          </ul>
                        </li>
                      </ol>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage: "assets/img/screenshots/lrg/home-header.jpg",
                      screenshot: "assets/img/screenshots/lrg/home-header.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Sneaker-pg.jpg",
                      screenshot: "assets/img/screenshots/lrg/Sneaker-pg.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Sneaker-pg-sneakers.jpg",
                      screenshot: "assets/img/screenshots/lrg/Sneaker-pg-sneakers.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Sneaker-detail.jpg",
                      screenshot: "assets/img/screenshots/lrg/Sneaker-detail.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Search-results.jpg",
                      screenshot: "assets/img/screenshots/lrg/Search-results.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Profiles-pg.jpg",
                      screenshot: "assets/img/screenshots/lrg/Profiles-pg.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Dashboard-pg-saved-content.jpg",
                      screenshot: "assets/img/screenshots/lrg/Dashboard-pg-saved-content.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Posts-detail.jpg",
                      screenshot: "assets/img/screenshots/lrg/Posts-detail.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/Article-detail.jpg",
                      screenshot: "assets/img/screenshots/lrg/Article-detail.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/Bb1hPFxVW4Y",
                      screenshot: "assets/img/screenshots/lrg/Article-Edit.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/rFbUyykMwbs",
                      screenshot: "assets/img/screenshots/lrg/Save-to-list.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/xnoqovij7I4",
                      screenshot: "assets/img/screenshots/lrg/Real-time-search.jpg",
                    },
                  ]}
                  gallery="11/6/2022"
                />
                <Updates
                  heading="UPDATE 9/2/2020"
                  desc={[
                    <>
                      <p>
                        There has been a slew of recent updates to this project. I added a filtering component that a user can use to filter through a list of items that is displayed on a page whether
                        they're posts, articles, sneakers, profiles. Changed the look of some of the site, to it an overall cleaner look. Added a reuseable modal component that is used for logging in,
                        or creating a new account. And could also be use in other areas of the site if necessary.
                      </p>

                      <p>
                        When a user clicks on an article, post, or sneaker listing, there will be section that displays links to items that are related to the currently loaded item. This is
                        accomplished by using tags thats the currently loaded item has, and matching them to any item that may have any matching tag.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage: "assets/img/filter.gif",
                      screenshot: "assets/img/filter.gif",
                    },
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=Yop42FM6XA",
                      screenshot: "assets/img/screenshots/lrg/login.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/OEwyIMg7JeE",
                      screenshot: "assets/img/screenshots/lrg/mostliked.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/vqtnQiJ1fvQ",
                      screenshot: "assets/img/screenshots/lrg/registration.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=0wNC6492hlg",
                      screenshot: "assets/img/screenshots/lrg/fwefwefewf.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=nN01mPaQVf8",
                      screenshot: "assets/img/screenshots/lrg/qewfdwqfdfq.jpg",
                    },
                  ]}
                  gallery="sole update"
                />
              </div>
            </>,
          ]}
          images={[
            <>
              <Imagerow images="assets/img/screenshots/lrg/landing-heading.jpg" />
              <Imagerow fullimage="https://www.youtube.com/watch?v=WnlLqsYHxm0" images="assets/img/screenshots/lrg/FireShot Capture 364 - SOCIAL SOLE - http___localhost_3001_allposts.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/sneaker-detail-yeezy.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/articles.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/6a7184cd3f8.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/FireShot Capture 337 - SOCIAL SOLE - http___localhost_3001_article_5f2f6d8e387b1f0f45e85ba9.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/community.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/latest-news.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/FireShot Capture 394 - SOCIAL SOLE - http___localhost_3001_post_5f56cd7995e2b32a547866ea.jpg" />
              <Imagerow images="assets/img/screenshots/lrg/5f2f683326006e0625abe26a.jpg" />
            </>,
          ]}
          style={{
            backgroundColor: "rgb(6 19 56)",
            opacity: "0.6",
          }}
        />
      </React.Fragment>
    );
  }
}

export default Sole;
